import { grabWorkOrderCounts, grabWorkOrders, grabWorkOrder, markWorkOrderNoCharge, voidWorkOrderRequest, setPONumberRequest, setDiscountRequest, setBillingOnlyRequest, setInvoiceNumberRequest, undoVoidWorkOrderRequest, undoNoChargeWorkOrderRequest, removeCustomerSignatureRequest, uploadCustomerSignedDocRequest, emailWorkOrderPdfRequest, sendWorkOrderSignatureRequestCall } from "../dataLayer/workOrders";

class WorkOrdersManager {

    // 0 = "all" (the v2 worklist's default view); 1-6 = a specific status filter
    selectedStatus: number = 0;
    selectedWorkOrderID: number = 0;
    selectedTrade: "Drywall" | "Paint" | "Other" | "" = "";
    selectedSupervisorIDs: number[] = [];

    async getWorkOrderCounts(): Promise<any> {
        try {
            const data = await grabWorkOrderCounts();
            console.log("Grab successful:", data);
            return data;
        } catch (error) {
            console.error("Error during grabbing work order counts:", error);
            throw error;
        }
    }

    async getWorkOrders(status?: number, trade?: string): Promise<any> {
        try {
            const data = await grabWorkOrders(status, trade);
            return data;
        } catch (error) {
            console.error("Error during grabbing work orders:", error);
            throw error;
        }
    }

    async getWorkOrder(workOrderID: number): Promise<any> {
        try {
            const data = await grabWorkOrder(workOrderID);
            return data;
        } catch (error) {
            console.error("Error during grabbing work order:", error);
            throw error;
        }
    }

    async markNoCharge(workOrderID: number, reason: string): Promise<any> {
        try {
            const data = await markWorkOrderNoCharge(workOrderID, reason);
            return data;
        } catch (error) {
            console.error("Error marking work order as no charge:", error);
            throw error;
        }
    }

    async voidWorkOrder(workOrderID: number, reason: string): Promise<any> {
        try {
            const data = await voidWorkOrderRequest(workOrderID, reason);
            return data;
        } catch (error) {
            console.error("Error voiding work order:", error);
            throw error;
        }
    }

    /** TAS-442 — resolves on 200 { message }; throws (400 { message }) once hours are claimed. */
    async setBillingOnly(workOrderID: number, billingOnly: boolean): Promise<{ message: string }> {
        try {
            const data = await setBillingOnlyRequest(workOrderID, billingOnly);
            return data;
        } catch (error) {
            console.error("Error setting billing-only on work order:", error);
            throw error;
        }
    }

    async setPONumber(workOrderID: number, poNumber: string): Promise<any> {
        try {
            const data = await setPONumberRequest(workOrderID, poNumber);
            return data;
        } catch (error) {
            console.error("Error setting PO number on work order:", error);
            throw error;
        }
    }

    async setDiscount(workOrderID: number, discountAmount: number): Promise<any> {
        try {
            const data = await setDiscountRequest(workOrderID, discountAmount);
            return data;
        } catch (error) {
            console.error("Error setting discount on work order:", error);
            throw error;
        }
    }

    async setInvoiceNumber(workOrderID: number, invoiceNumber: string): Promise<any> {
        try {
            const data = await setInvoiceNumberRequest(workOrderID, invoiceNumber);
            return data;
        } catch (error) {
            console.error("Error setting invoice number on work order:", error);
            throw error;
        }
    }

    async undoVoid(workOrderID: number): Promise<any> {
        try {
            const data = await undoVoidWorkOrderRequest(workOrderID);
            return data;
        } catch (error) {
            console.error("Error undoing void on work order:", error);
            throw error;
        }
    }

    async undoNoCharge(workOrderID: number): Promise<any> {
        try {
            const data = await undoNoChargeWorkOrderRequest(workOrderID);
            return data;
        } catch (error) {
            console.error("Error undoing No Charge on work order:", error);
            throw error;
        }
    }

    /**
     * Removes a customer signature taken in error, reopening the work order for
     * signature. The reason is recorded in the work order's status history.
     */
    async removeCustomerSignature(workOrderID: number, reason: string): Promise<any> {
        try {
            const data = await removeCustomerSignatureRequest(workOrderID, reason);
            return data;
        } catch (error) {
            console.error("Error removing customer signature on work order:", error);
            throw error;
        }
    }

    async uploadCustomerSignedDoc(workOrderID: number, file: File, notes?: string): Promise<any> {
        try {
            const data = await uploadCustomerSignedDocRequest(workOrderID, file, notes);
            return data;
        } catch (error) {
            console.error("Error uploading customer signed document:", error);
            throw error;
        }
    }

    async emailWorkOrderPdf(
        workOrderID: number,
        payload: { recipient: string; recipients?: string[]; cc?: string[]; subject?: string; body?: string }
    ): Promise<any> {
        try {
            const data = await emailWorkOrderPdfRequest(workOrderID, payload);
            return data;
        } catch (error) {
            console.error("Error emailing work order PDF:", error);
            throw error;
        }
    }

    async sendSignatureRequest(workOrderID: number, payload: { recipient: string }): Promise<any> {
        try {
            const data = await sendWorkOrderSignatureRequestCall(workOrderID, payload);
            return data;
        } catch (error) {
            console.error("Error sending signature request:", error);
            throw error;
        }
    }

}

export default new WorkOrdersManager();
